import { CheckCircle2, XCircle, Info, Link2 } from "lucide-react";
import { GooglePreview } from "@/components/sales/draft/GooglePreview";
import { PagePreview } from "@/components/sales/draft/PagePreview";

// SEARCH-READY (S2.4, D107): the checklist that gates approval, the web address, how it looks in Google and the
// page itself with its structured data — all made from the public listing only. A ✗ line stops approval; a tip doesn't.
export function DraftSeo({ v }) {
  const s = v.seo;
  if (!s) return null;
  const gate = s.checks.filter((c) => c.gate);
  const tips = s.checks.filter((c) => !c.gate);
  return (
    <section data-testid="sales-draft-seo" className="rounded-xl border border-slate-200 bg-white p-3 space-y-4">
      <div>
        <div className="font-bold text-slate-900">Search-ready — the checklist</div>
        <p className="text-xs text-slate-600">A line with ✗ stops approval until it passes. Tips never stop it.</p>
      </div>
      <ul data-testid="sales-draft-seo-checks" className="space-y-1.5 text-sm">
        {gate.map((c) => (
          <li key={c.key} data-testid={`sales-draft-seo-check-${c.key}`} data-ok={c.ok ? "yes" : "no"}
            className={`flex items-start gap-2 ${c.ok ? "text-emerald-900" : "text-[#8B1820] font-semibold"}`}>
            {c.ok ? <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0 text-emerald-700" /> : <XCircle className="w-4 h-4 mt-0.5 shrink-0" />}
            <span className="break-words min-w-0">{c.words}</span>
          </li>
        ))}
      </ul>
      {tips.length > 0 && (
        <ul data-testid="sales-draft-seo-tips" className="space-y-1 text-xs text-slate-700 border-t border-slate-100 pt-3">
          {tips.map((c) => <li key={c.key} data-testid={`sales-draft-seo-tip-${c.key}`} className="flex items-start gap-2"><Info className="w-4 h-4 shrink-0 text-slate-400" />{c.words}</li>)}
        </ul>
      )}
      <Address a={s.address} />
      <GooglePreview g={s.google} />
      <PagePreview v={v} sd={s.structured_data} />
    </section>
  );
}

function Address({ a }) {
  return (
    <div data-testid="sales-draft-seo-address" className="rounded-lg border border-slate-200 bg-slate-50 p-3 text-sm space-y-1">
      <div className="flex items-center gap-2 font-semibold text-slate-800"><Link2 className="w-4 h-4" />Web address</div>
      <div data-testid="sales-draft-seo-address-path" className="font-mono text-xs break-all text-slate-900">{a.path || "(not made yet — see the checklist)"}</div>
      <p data-testid="sales-draft-seo-address-fixed" className="text-xs text-slate-600">
        {a.fixed ? "Fixed for good — it was set the first time it was published. Changing the title never moves it."
          : "Made from the listing's own words for now. It is fixed for good the first time it is published, so a later typo fix never breaks a link."}
      </p>
    </div>
  );
}
